import { Skeleton } from '@Components/ui-v2/skeleton';

interface JourneyCardSkeletonProps {
  compact?: boolean;
  fullWidth?: boolean;
}

const JourneyCardSkeleton = ({ compact = false, fullWidth = false }: JourneyCardSkeletonProps) => {
  return (
    <div
      className={`agent-journey-card${compact ? '' : ' h-full'}${fullWidth ? ' sm:col-span-2' : ''}`}
      style={{ ['--agent-journey-accent' as string]: '#e5e7eb' }}>
      <div
        className={`relative z-[2] flex w-full flex-col gap-2 rounded-[14px] bg-transparent ${
          compact ? 'px-3.5 py-3' : 'h-full p-5'
        }`}>
        <Skeleton className="inline-flex h-4 w-24 rounded-full bg-gray-200" />
        <Skeleton className="block h-3 w-3/4 rounded-full bg-gray-100" />
      </div>
    </div>
  );
};

export default JourneyCardSkeleton;
